import { Product } from '@virginexperiencedays/products';
import { getDimension6, getSingleSupplierName } from '../../../tracking/utils';
import { getPreviousCategory } from './previousCategory';

export const productView = (product: Product) => {
  const {
    title,
    id,
    sku,
    promocode,
    categoryHierarchy,
    price: { displayPrice } = { displayPrice: null },
    price,
    searchIndex,
    suppliers,
    isCollectionProduct,
  } = product;
  const { lvl0 } = categoryHierarchy ?? {};
  const fullSku = promocode ? `${sku} ${promocode}` : sku;

  const previousCategory = getPreviousCategory();

  return {
    event: 'view_item',
    ecommerce: {
      detail: {
        actionField: previousCategory ? { list: previousCategory } : {},
        products: [
          {
            name: title,
            id: fullSku,
            price: displayPrice,
            brand: getSingleSupplierName(suppliers, isCollectionProduct),
            category: lvl0,
            dimension6: getDimension6({ price }),
            metric6: 0,
            br_prod_id: id.toString(),
            searchIndex: searchIndex?.toString(),
            currency: 'GBP',
          },
        ],
      },
    },
  };
};
